import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {TransitionProps} from '@material-ui/core/transitions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ModalDialog({
                         open,
                         onClose,
                         title,
                         content,
                         actions, maxWidth
                     }: { open: boolean, onClose: () => void, title: any, content: any, actions?: any,
    maxWidth?:  false | "xs" | "sm" | "md" | "lg" | "xl" | undefined}) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={onClose}
            maxWidth={maxWidth || 'xs'}
        >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            {actions ?
                <DialogActions>
                    {actions}
                </DialogActions> : null}
        </Dialog>
    );
}

export default ModalDialog;